import React from "react";

const StudentPageContext = React.createContext();

export { StudentPageContext };
